
import { Product } from "@/types/product";

export const brakeProducts: Product[] = [
  {
    id: "brake-disc",
    name: "BRAKE DISC",
    description: "Circular metal plates attached to the wheel hub that slow or stop the vehicle when pressed against brake pads. Made from high-quality cast iron or carbon composite materials, our brake discs ensure optimal friction, heat dissipation, and resistance to wear and tear. Designed for superior braking performance and longevity, they provide safe and consistent stopping power.",
    images: ["/assets/brake-disc/33.webp", "/assets/brake-disc/34.webp", "/assets/brake-disc/35.webp", "/assets/brake-disc/36.webp"],
    certifications: ["ISO 9001:2015", "TS 16949", "CE Certified"],
    minOrderQuantity: "100 units",
    availableFor: [
      "ASHOK LEYLAND", "AUDI", "BMW", "CHEVROLET", "DAEWOO", "DATSUN", "FORCE", 
      "FIAT", "FORD", "HYUNDAI", "HONDA", "ISUZU", "JAGUAR", "JEEP", "KIA", 
      "LAND ROVER", "SUZUKI", "MAHINDRA", "MB", "MITSUBISHI", "MG", "NISSAN", 
      "OPEL", "RENAULT", "SKODA", "SONALIKA", "TATA", "TOYOTA", "VW"
    ],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Brake Disc exporter to Global Markets | ISO 9001:2015, TS 16949 Certified | 2024 Verified Supplier"
  },
  {
    id: "brake-drum",
    name: "BRAKE DRUM",
    description: "Cylindrical braking components that use brake shoes to create friction, effectively slowing or stopping the vehicle. Manufactured from reinforced cast iron or steel, our brake drums are built for durability and efficient heat management, preventing brake fade and ensuring smooth operation.",
    images: ["/assets/brake-drum/73.webp", "/assets/brake-drum/74.webp", "/assets/brake-drum/75.webp", "/assets/brake-drum/76.webp"],
    certifications: ["ISO 9001:2015"],
    minOrderQuantity: "100 units",
    availableFor: [
      "ASHOK LEYLAND", "CHEVROLET", "FORCE", "FORD", "HYUNDAI", "HONDA", 
      "ISUZU", "SUZUKI", "MAHINDRA", "MITSUBISHI", "NISSAN", "OPEL", 
      "RENAULT", "SKODA", "SONALIKA", "TATA", "TOYOTA", "VW"
    ],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Brake Drum exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  }
];
